import { render, staticRenderFns } from "./EnglishResumePrMessageCard.vue?vue&type=template&id=0dfb41e6"
import script from "./EnglishResumePrMessageCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnglishResumePrMessageCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports